export default __webpack_public_path__ + "static/media/common-misconceptions-about-payment.e5b2c5dc.md";